import React, {useState} from 'react';
import {StyledEngineProvider, ThemeProvider} from '@mui/material';
import {themeCreator} from './base';
import {StylesProvider} from '@mui/styles';

export const ThemeContext = React.createContext(
  (themeName: string): void => { }
);

const ThemeProviderWrapper: React.FC = (props) => {
  const curThemeName = localStorage.getItem('appTheme') || 'PureLightTheme';
  const [themeName, _setThemeName] = useState(curThemeName);
  const theme = themeCreator(themeName);
  const setThemeName = (themeName: string): void => {
    localStorage.setItem('appTheme', themeName);
    _setThemeName(themeName);
  };

  return (
    <StylesProvider injectFirst>
      <ThemeContext.Provider value={setThemeName}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>{props.children}</ThemeProvider >
        </StyledEngineProvider>
      </ThemeContext.Provider>
    </StylesProvider>
  );
};

export default ThemeProviderWrapper;
